import React from "react";
import { FileText, Globe, MapPin, Clock } from "lucide-react";

// All values are factual / compliant — no success-rate or outcome claims.
const STATS = [
  { id: "platforms", icon: Globe, value: "5", label: "Platforms covered" },
  { id: "response", icon: Clock, value: "24h", label: "Intake response window" },
  { id: "scope", icon: FileText, value: "10+", label: "Documentation formats" },
  { id: "location", icon: MapPin, value: "USA", label: "Honolulu, Hawaii LLC" },
];

export const StatStrip = () => (
  <section className="border-y border-white/10 bg-slate-900/60" data-testid="stat-strip">
    <div className="mx-auto max-w-7xl px-6 py-10">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {STATS.map((stat) => {
          const Icon = stat.icon;
          return (
            <div
              key={stat.id}
              className="flex items-center gap-4"
              data-testid={`stat-${stat.id}`}
            >
              <div className="w-12 h-12 rounded-xl bg-blue-500/10 border border-blue-500/30 flex items-center justify-center flex-shrink-0">
                <Icon className="w-5 h-5 text-blue-400" />
              </div>
              <div>
                <p className="text-2xl font-bold text-white leading-none">{stat.value}</p>
                <p className="text-xs text-slate-400 mt-1">{stat.label}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
